import { useState, useEffect } from "react";
import { administrationService } from "../dependencyInjection";
import { AdministrationError } from "../services/AdministrationService";

export function useAdministrationError(): [AdministrationError | null] {
  const [errorCode, setErrorCode] = useState<AdministrationError | null>(null);
  useEffect(() => {
    
    const sub = administrationService.error$.subscribe((code) => {
      setErrorCode(code);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  return [errorCode];
}
